import { ApiService } from "@/api";
import { TemplateEntity } from "./../../../../../types/templates/template.interface";
import { ResponseBody } from "../../../../../types/response/response-body.interface";

export const fetchTemplates = async (): Promise<ResponseBody<TemplateEntity>> => {
  return ApiService.baseAction("template/list", {});
};
